export default __webpack_public_path__ + "static/media/tmov-logo-light.64b55eee.svg";